import HttpService from "./HttpService";
import store from '../store/store';

export default class LivenessLogService extends HttpService {
    constructor(props) {
        super(props);
    }

    getDeviceInfo(){
        let parser = new UAParser(navigator.userAgent);
        let result = parser.getResult();
        let osName = result.os.name ? result.os.name : '';
        let deviceName = result.device.name ? result.device.name : '';
        let deviceModel = osName+' '+deviceName;
        return {
            deviceModel: deviceModel ? deviceModel : '',
            deviceVersion: result.os.version ? result.os.version  : ''
        }
    }

    sendLogLiveness(stsLiveness,sessionId,codErro,descErro){
        let idLink = store.getters.dados.id_link;
        let dados = Object.assign({idLink,sessionId,stsLiveness,codErro,descErro},this.getDeviceInfo());

        return this._post('capturav1/salvarLogLiveness',dados);
    }
}



// WEBPACK FOOTER //
// ./src/services/LivenessLogService.js